
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Zuerst sollte man sich über die Erkrankung informieren. Dann kann die Behandlung
mit Entspannungstraining (z.B. progressive Muskelrelaxation nach Jacobson oder
autogenes Training) helfen. Auch Musiktherapie und/oder
Stressbewältigungstraining sowie Biofeedback können hilfreich sein. Den Hals-
und Schultermuskeln tut Physiotherapie mit Training, Dehnübungen und Massage
gut. Auch Antidepressiva werden zur Behandlung eingesetzt.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;